<!-- 旅游模块右侧的模块，根据父组件的传值来决定显示什么 -->
<template>
 <div class="travelRight">
   <h2 class="title">相关推荐</h2>
    <ul class="relul" :class="currentType">
        <li v-for="(item, index) in List" :key="index" :style="{backgroundImage: 'url('+item.imgPath+')'}">
          <a :href="item.adLink" target="_blank">
            <h2>{{ item.adName }}</h2>
            <p v-if="item.adDesc !== undefined && item.adDesc !== ''">{{ item.adDesc }}</p>
          </a>
        </li>
    </ul>
 </div>
</template>

<script>
import { getfrontslot } from '../../api/userservice'
export default {
  components: {
  },
  data () {
    return {
      currentType: '',
      params: {
        museumCode: this.$cookie.get('museumCode'),
        slotName: '',
        slotCode: ''
      },
      List: []
    }
  },
  mounted () {
    this.currentType = this.$route.name
    this.getSlot()
  },
  methods: {
    getSlot () {
      this.params.slotName = this.$route.name + 'Right'
      getfrontslot(this.params).then(res => {
        console.log(res)
        console.log(res.data.status)
        if (res.data.status === 200) {
          if (res.data.data.rows.length > 0) {
            if (res.data.data.rows[0].adDetails.length > 0) {
              this.List = res.data.data.rows[0].adDetails
            }
          }
        }
      })
    }
  }
}

</script>

<style lang='scss' scoped>
.title {
    font-size: 18px;
    line-height: 54px;
    font-weight: 600;
}
.graident1{
  background: -webkit-linear-gradient(top, #b74c4c , #cc6e6e);
  background: -o-linear-gradient(bottom, #b74c4c, #cc6e6e);
  background: -moz-linear-gradient(bottom, #b74c4c, #cc6e6e);
  background: linear-gradient(to bottom, #b74c4c , #cc6e6e);
}
.graident2{
  background: -webkit-linear-gradient(top, #d9a555 , #f1ce8c);
  background: -o-linear-gradient(bottom, #d9a555, #f1ce8c);
  background: -moz-linear-gradient(bottom, #d9a555, #f1ce8c);
  background: linear-gradient(to bottom, #d9a555 , #f1ce8c);
}
.relul li {
  width: 100%;
  height: 136px;
  margin-bottom: 20px;
  border-radius: 10px;
  overflow: hidden;
  background-size: 100% 100%;
  a{
    display: block;
    padding: 30px 30px;
    position: relative;
    h2,p{
      color: #fff;
    }
    h2{
      height: 40px;
      position: relative;
      margin-bottom: 12px;
      &:after {
        position: absolute;
        display: block;
        content: '';
        width: 30px;
        height: 1px;
        background: #fff;
        bottom: 0;
        left: 0;
      }
    }
    img {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
  &:hover{
    a{
      h2{
        &:after {
          width: 90px;
          transition: all 0.3s;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/travelRight/index.vue